import { render, staticRenderFns } from "./frontTerminosCondicionesContainer.vue?vue&type=template&id=1585a710&scoped=true&"
import script from "./frontTerminosCondicionesContainer.vue?vue&type=script&lang=js&"
export * from "./frontTerminosCondicionesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585a710",
  null
  
)

export default component.exports